import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { LogoMark } from "@/components/site/Logo";
import { http, errMsg } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    document.title = "Owner login | Assemble Pro";
    http.get("/auth/me").then(() => nav("/admin/quotes")).catch(() => {});
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await http.post("/auth/login", { email, password });
      nav("/admin/quotes");
    } catch (err) {
      setError(errMsg(err));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[var(--ink)] blueprint px-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md border border-[var(--line)] bg-[var(--char)] p-8 sm:p-10" data-testid="admin-login-form">
        <LogoMark className="w-12 h-12" />
        <h1 className="mt-6 font-display font-black uppercase text-4xl">Owner login</h1>
        <p className="text-zinc-400 text-sm mt-2 flex items-center gap-2"><Lock className="w-3.5 h-3.5" />Quote requests dashboard</p>
        <div className="mt-8 space-y-4">
          <input className="field" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" />
          <input className="field" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" />
        </div>
        {error && <p className="mt-4 text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
        <button disabled={busy} className="btn-orange w-full justify-center py-4 mt-6 text-lg" data-testid="admin-login-btn">
          {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <span>Sign in</span>}
        </button>
      </form>
    </div>
  );
}
